import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import styles from "./reviewSharedData.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { deleteComment, addComment } from "./reviewSharedDataSlice";
import { v4 } from "uuid";
import { selectUser } from "../../app/appSlice";
import sharedDataApi from "../../api/sharedDataApi";
import RenderComments from "./RenderComments";

// Component to render key-value pairs with hover effect
const KeyValuePair = ({ label, value }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isTextBoxVisible, setIsTextBoxVisible] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [disableAddComment, setDisableAddComment] = useState(false);

  const comments = useSelector((state) => state.reviewSharedData.comments);
  const actionItemDetails = useSelector(
    (state) => state.reviewSharedData.actionItemData
  );
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  // Filter comments based on label (property_name)
  const hasComments = comments.some(
    (comment) => comment.property_name === label
  );

  const handleAddComment = async (e) => {
    setDisableAddComment(true);
    try {
      const payload = {
        commentId: v4(),
        name: user.email,
        date: new Date().toString(),
        text: commentText,
        parent_comment_id: null,
        property_name: label,
        actionId: actionItemDetails.id,
      };

      await sharedDataApi.createComment({
        input: { ...payload, date: new Date(payload.date) },
      });

      dispatch(addComment(payload));
      handleCancel();
      setDisableAddComment(false);
    } catch (err) {
      setDisableAddComment(false);
    }
  };

  const handleCancel = () => {
    setIsTextBoxVisible(false);
    setCommentText("");
  };

  return (
    <>
      <td>{label.replace(/([A-Z])/g, "$1").trim()}</td>
      <td>{value ? value.toString() : value}</td>
      <td
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Show FaPlus only if there are no comments and status is not approved */}
        {isHovered &&
          !hasComments &&
          ["In_Review", "Staging", "Pre_Prod"].includes(actionItemDetails.State) &&
          (user.email === actionItemDetails.CreatedByEmail ||
            actionItemDetails.ReviewerEmails?.includes(user.email)) && (
            <FaPlus onClick={() => setIsTextBoxVisible(!isTextBoxVisible)} />
          )}
        {isTextBoxVisible && (
          <div className={styles.commentBox}>
            <textarea
              onChange={(e) => setCommentText(e.target.value)}
              value={commentText}
              placeholder="Write a Comment"
            ></textarea>
            <div className={styles.commentBoxButtons}>
              <button
                disabled={commentText === "" || disableAddComment}
                onClick={handleAddComment}
              >
                Add New Comment
              </button>
              <button onClick={handleCancel}>Cancel</button>
            </div>
          </div>
        )}
        <RenderComments comments={comments} label={label} />
      </td>
    </>
  );
};

export default KeyValuePair;
